export default "__VITE_ASSET__p90adyIv__"